import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  async refresh() {
    if (!this.hasUrlValue) return

    try {
      const response = await fetch(this.urlValue, {
        headers: { Accept: "text/html" }
      })
      if (!response.ok) return

      const html = await response.text()
      const temp = document.createElement("div")
      temp.innerHTML = html.trim()
      const newNode = temp.firstElementChild
      if (!newNode) return

      document.querySelectorAll(".end-session-progress-wrapper").forEach(el => {
        el.replaceWith(newNode.cloneNode(true))
      })
    } catch (_e) {
      // Non-critical — modal will show last known progress
    }
  }
}
